import { IconProps } from '@components/Icons/Menu/index';

const defaultSize = 24;

export const CashManagementIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.625 14.125C12.7917 14.125 12.0833 13.8333 11.5 13.25C10.9167 12.6667 10.625 11.9583 10.625 11.125C10.625 10.2917 10.9167 9.58333 11.5 9C12.0833 8.41667 12.7917 8.125 13.625 8.125C14.4583 8.125 15.1667 8.41667 15.75 9C16.3333 9.58333 16.625 10.2917 16.625 11.125C16.625 11.9583 16.3333 12.6667 15.75 13.25C15.1667 13.8333 14.4583 14.125 13.625 14.125ZM5.625 17.625C5.20833 17.625 4.85417 17.4792 4.5625 17.1875C4.27083 16.8958 4.125 16.5417 4.125 16.125V6.125C4.125 5.70833 4.27083 5.35417 4.5625 5.0625C4.85417 4.77083 5.20833 4.625 5.625 4.625H21.625C22.0417 4.625 22.3958 4.77083 22.6875 5.0625C22.9792 5.35417 23.125 5.70833 23.125 6.125V16.125C23.125 16.5417 22.9792 16.8958 22.6875 17.1875C22.3958 17.4792 22.0417 17.625 21.625 17.625H5.625ZM8.125 16.125H19.125C19.125 15.425 19.3667 14.8333 19.85 14.35C20.3333 13.8667 20.925 13.625 21.625 13.625V8.625C20.925 8.625 20.3333 8.38333 19.85 7.9C19.3667 7.41667 19.125 6.825 19.125 6.125H8.125C8.125 6.825 7.88333 7.41667 7.4 7.9C6.91667 8.38333 6.325 8.625 5.625 8.625V13.625C6.325 13.625 6.91667 13.8667 7.4 14.35C7.88333 14.8333 8.125 15.425 8.125 16.125ZM20.125 20.625H2.625C2.20833 20.625 1.85417 20.4792 1.5625 20.1875C1.27083 19.8958 1.125 19.5417 1.125 19.125V7.625H2.625V19.125H20.125V20.625Z"
        fill="white"
      />
    </svg>
  );
};
